<template>
    <div class="main-app row">
        <ListTax @update-url="updateUrl" @update-TermsObjects="updateTermsObjects" :filteredTerms="filteredTerms"/>
        <ListPosts @update-terms="updateFilteredTerms" :selectedTerms="selectedTerms" :selectedTermsObjects="selectedTermsObjects" />
    </div>
</template>
  
<script>
    import ListTax from '@/components/ListTax'
    import ListPosts from '@/components/ListPosts'

    export default {
        name: 'MainApp',
        components: {
            ListTax,
            ListPosts,
        },
        data() {
            return {
                selectedTerms: [],
                selectedTermsObjects:[],
                filteredTerms : []
            }
        },
        methods: {
            updateUrl(newFilters) {
                console.log('newfilter',newFilters)
                this.selectedTerms = newFilters;
            },
            updateTermsObjects(Terms) {
                console.log('newTerms',Terms)
                this.selectedTermsObjects = Terms;
            },
            updateFilteredTerms(filteredTerms){
                console.log('filteredTerms',filteredTerms)
                this.filteredTerms = filteredTerms
            }
        },     
    }
</script>

<style>
  .grey-bg{
    background-color: #fafafa;
  }
  .spinner {
    border: 2px solid #f3f3f3;
    border-top: 2px solid #003d88;
    border-radius: 50%;
    width: 6rem;
    height: 6rem;
    animation: spin 1s linear infinite;
    margin: 0 auto;
    top: 100%;
    position: relative;
}
@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}
</style>
  